import { render, staticRenderFns } from "./SquareIcon.vue?vue&type=template&id=d597f49a&scoped=true&"
import script from "./SquareIcon.vue?vue&type=script&lang=js&"
export * from "./SquareIcon.vue?vue&type=script&lang=js&"
import style0 from "./SquareIcon.vue?vue&type=style&index=0&id=d597f49a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d597f49a",
  null
  
)

export default component.exports